import { css } from '@emotion/react'
import { mdiAccountCogOutline } from '@mdi/js'
import Icon from '@mdi/react'
import i18n from '../../utilities/i18n'
import { getThemeSpacing } from '../styles/appTheme'
import Button from './Button'

interface IButtonChange {
    onClick(event?: any): any
}

const rightButtonStyles = css({
    right: 20,
})

const labelStyles = css({
    paddingLeft: getThemeSpacing(0.5),
})

const overrides = css({
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
})

const ButtonChange = ({ onClick }: IButtonChange) => {
    const label = i18n.t('buttons.change')
    return (
        <div css={rightButtonStyles}>
            <Button
                onClick={onClick}
                data-testid="Button__WhoCanWatchChange"
                id="Button__WhoCanWatchChange"
                css={overrides}
                clean
            >
                <Icon path={mdiAccountCogOutline} title={label} size={1} />
                <span css={labelStyles}>{label}</span>
            </Button>
        </div>
    )
}

export default ButtonChange
